<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title"></h4>
                        <p class="category"></p>
                    </div> 

                    <div class="text-right">
                        <i (click)="openModal()" class="material-icons">add</i>
                    </div>
                    <div class="container-fluid">
                        <div class="table-responsive">
                            <table id="table" class="table table-striped " cellspacing="0" width="100%">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!--*ngFor="let row of data; let i = index"-->
                                    <tr>
                                        <td>1</td>
                                        <td>General</td>
                                        <td><i class="material-icons">edit</i><i class="material-icons">delete</i></td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td>Sports</td>
                                        <td><i class="material-icons">edit</i><i class="material-icons">delete</i></td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td>Business</td>
                                        <td><i class="material-icons">edit</i><i class="material-icons">delete</i></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-new-niche-modal #newniche></app-new-niche-modal>